import type { FC } from "react";
import { DashboardCardSlider } from "web_myplann/Dashboard/Components/DashboardCardSlider";
import type { AnimationDirection } from "web_myplann/Dashboard/Hooks/useDashboardAnimation";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";
import type { DashboardSlide } from "web_myplann/Dashboard/Types/DashboardSlide";
import { isGoalsSlide } from "web_myplann/Dashboard/Utils/isGoalsSlide";
import { DashboardAnimatedContent } from "./DashboardAnimatedContent";

type Props = {
	dashboard: DashboardSlide;
	previousDashboard: DashboardSlide | null;
	isAnimating: boolean;
	animationDirection: AnimationDirection;
	isDashboardDetail?: boolean;
	navigateToDashboardDetail?: () => void;
	onTooltipToggle?: (open: boolean) => void;
};

export const DashboardCardCarouselResolver: FC<Props> = ({
	dashboard,
	previousDashboard,
	isAnimating,
	animationDirection,
	isDashboardDetail,
	navigateToDashboardDetail,
	onTooltipToggle,
}) => {
	const isDashboardV2 = useIsDashboardV2();

	if ((isDashboardV2 && !isDashboardDetail) || isGoalsSlide(dashboard)) {
		return (
			<DashboardCardSlider
				dashboard={dashboard}
				direction={animationDirection}
				navigateToDashboardDetail={navigateToDashboardDetail}
				onTooltipToggle={onTooltipToggle}
			/>
		);
	}

	return (
		<>
			<DashboardAnimatedContent
				dashboardData={dashboard}
				isAnimating={isAnimating}
				isPrevious={false}
				animationDirection={animationDirection}
				isDashboardDetail={isDashboardDetail}
				navigateToDashboardDetail={navigateToDashboardDetail}
				onTooltipToggle={onTooltipToggle}
			/>

			{isAnimating && previousDashboard && !isGoalsSlide(previousDashboard) && (
				<DashboardAnimatedContent
					dashboardData={previousDashboard}
					isAnimating={isAnimating}
					isPrevious={true}
					animationDirection={animationDirection}
					isDashboardDetail={isDashboardDetail}
					navigateToDashboardDetail={navigateToDashboardDetail}
				/>
			)}
		</>
	);
};
